import { Flex, Grid, Skeleton } from '@mantine/core';

import styles from './OverviewSkeleton.module.scss';

const OverviewSkeleton = () => {
  return (
    <Grid gutter={0} className={styles.container}>
      <Grid.Col span={12}>
        <Flex className={styles.topSection}>
          <Skeleton h={120} w="100%" />
          <Skeleton h={120} w="100%" />
        </Flex>
      </Grid.Col>

      <Grid.Col span={12}>
        <Grid.Col span={12}>
          <Flex className={styles.middleSection}>
            <Skeleton h={40} w="100%" />
            <Skeleton h={40} w="100%" />
          </Flex>
        </Grid.Col>

        <Grid gutter={0}>
          <Grid.Col span={8} style={{ borderRight: '1px solid #E0E0E0' }} p="10px">
            <Skeleton style={{ height: 'calc(100vh - 300px)' }} />
          </Grid.Col>
          <Grid.Col span={4} p="10px">
            <Skeleton style={{ height: 'calc(100vh - 300px)' }} />
          </Grid.Col>
        </Grid>
      </Grid.Col>
    </Grid>
  );
};

export default OverviewSkeleton;
